<div class="bg-gradient-to-br from-blue-50 via-white to-indigo-50 dark:from-slate-900 dark:via-slate-900 dark:to-slate-900 p-4">
  <div class="max-w-5xl mx-auto">
    <!-- Barre de progression -->
    <app-progress-bar
      [currentStep]="currentStep"
      [totalSteps]="totalSteps"
    ></app-progress-bar>

    <!-- Titre -->
    <h2 class="text-xl font-bold mb-1 mt-3">
      Décrivez votre activité itinérante
    </h2>
    <p class="text-gray-600 dark:text-gray-400 text-xs mb-3">
      Renseignez ces informations pour personnaliser nos recommandations.
    </p>

    <!-- Formulaire -->
    <form [formGroup]="form" class="mb-4">
      <!-- Grid 2 colonnes -->
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-3">
        <!-- Colonne 1 : Types d'événements (prend toute la largeur sur mobile, 2 colonnes sur desktop) -->
        <div
          class="lg:col-span-2 bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700"
          >
          <h3 class="text-sm font-bold mb-1 text-gray-900 dark:text-white">
            🎪 Types d'événements (Sélectionner au moins 1)
          </h3>
          <p class="text-[10px] text-gray-600 dark:text-gray-400 mb-2">
            Quels types d'événements fréquentez-vous ?
          </p>

          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-2">
            @for (option of eventTypeOptions; track option) {
              <button
                type="button"
                (click)="toggleEventType(option.id)"
                class="p-2 rounded-lg border-2 font-medium transition-all duration-200 text-left flex items-start gap-2"
              [ngClass]="{
                'bg-green-50 dark:bg-green-900/20 border-green-600 text-green-900':
                  isEventTypeSelected(option.id),
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-green-300 hover:bg-green-50 dark:bg-green-900/20':
                  !isEventTypeSelected(option.id),
              }"
                >
                <!-- Checkbox -->
                <div class="flex-shrink-0 mt-0.5">
                  <div
                    class="w-4 h-4 rounded border-2 transition-all"
                  [ngClass]="{
                    'bg-green-600 border-green-600': isEventTypeSelected(
                      option.id
                    ),
                    'border-gray-300 dark:border-slate-600 bg-white dark:bg-slate-800': !isEventTypeSelected(option.id),
                  }"
                    >
                    @if (isEventTypeSelected(option.id)) {
                      <svg
                        class="w-3 h-3 text-white m-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        >
                        <path
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          stroke-width="3"
                          d="M5 13l4 4L19 7"
                        ></path>
                      </svg>
                    }
                  </div>
                </div>
                <!-- Contenu -->
                <div class="flex-1">
                  <div class="text-xs font-semibold">{{ option.label }}</div>
                  <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                    {{ option.description }}
                  </div>
                </div>
              </button>
            }
          </div>
        </div>

        <!-- Colonne 2 : Couverture habituelle -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-1 text-gray-900 dark:text-white">
            ☀️ Exposition aux conditions météo
          </h3>
          <p class="text-[10px] text-gray-600 dark:text-gray-400 mb-2">
            Votre point de vente est-il protégé des intempéries ?
          </p>

          <div class="grid grid-cols-1 gap-2">
            @for (option of coverageOptions; track option) {
              <button
                type="button"
                (click)="selectCoverage(option.id)"
                class="p-2 rounded-lg border-2 font-medium transition-all duration-200 text-left"
              [ngClass]="{
                'bg-green-50 dark:bg-green-900/20 border-green-600 text-green-900':
                  form.value.coverage === option.id,
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-green-300 hover:bg-green-50 dark:bg-green-900/20':
                  form.value.coverage !== option.id,
              }"
                >
                <div class="text-xs font-semibold">{{ option.label }}</div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                  {{ option.description }}
                </div>
              </button>
            }
          </div>
        </div>

        <!-- Colonne 3 : Taille équipe habituelle -->
        <div class="bg-white dark:bg-slate-800 p-3 rounded-lg border border-gray-200 dark:border-slate-700">
          <h3 class="text-sm font-bold mb-1 text-gray-900 dark:text-white">
            👥 Taille équipe habituelle
          </h3>
          <p class="text-[10px] text-gray-600 dark:text-gray-400 mb-2">
            Combien de personnes travaillent habituellement avec vous ?
          </p>

          <div class="grid grid-cols-1 gap-2">
            @for (option of teamSizeOptions; track option) {
              <button
                type="button"
                (click)="selectTeamSize(option.id)"
                class="p-2 rounded-lg border-2 font-medium transition-all duration-200 text-left"
              [ngClass]="{
                'bg-green-50 dark:bg-green-900/20 border-green-600 text-green-900': isFieldSelected(
                  'teamSize',
                  option.id
                ),
                'bg-gray-50 dark:bg-slate-900 border-gray-300 dark:border-slate-600 text-gray-700 dark:text-gray-300 hover:border-green-300 hover:bg-green-50 dark:bg-green-900/20':
                  !isFieldSelected('teamSize', option.id),
              }"
                >
                <div class="text-xs font-semibold">{{ option.label }}</div>
                <div class="text-[10px] text-gray-500 dark:text-gray-400 mt-0.5">
                  {{ option.description }}
                </div>
              </button>
            }
          </div>
        </div>
      </div>
    </form>

    <!-- V1 — Positionnement tarifaire -->
    <div class="mt-3">
      <app-positioning-selector
        [selectedPositioning]="selectedPositioning"
        (positioningChange)="selectedPositioning = $event"
      ></app-positioning-selector>
    </div>

    <!-- Boutons de navigation -->
    <div class="flex justify-between mt-6 mb-2">
      <!-- Bouton Retour -->
      <button
        (click)="goBack()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-colors bg-gray-200 dark:bg-slate-700 text-gray-700 dark:text-gray-300 hover:bg-gray-300 dark:hover:bg-slate-600 hover:text-gray-900 dark:hover:text-white dark:text-white"
        >
        ← Précédent
      </button>

      <!-- Bouton Continuer -->
      <button
        (click)="continue()"
        class="flex items-center gap-2 px-4 py-1.5 text-sm font-medium rounded-lg transition-all bg-indigo-600 text-white hover:bg-indigo-700 disabled:bg-gray-300 disabled:text-gray-500 dark:text-gray-400 disabled:cursor-not-allowed"
        [disabled]="!form.valid"
        >
        Continuer →
      </button>
    </div>
  </div>
</div>
